import {
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';

import { ContactList, isFullyPersonalizable, Mailer } from '../../../../configuration-module/providers/mailers.provider';

@Component({
    selector: 'app-mediego-setup-sending-config',
    templateUrl: './setup-sending-config.component.html',
    styleUrls: ['./setup-sending-config.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SetupSendingConfigComponent {

  @Input() sendingConfigForm: UntypedFormGroup;
  @Input() contactsMailers: Mailer[] = [];
  @Input() sendingMailers: Mailer[] = [];
  @Input() contactsListsForMailer: ContactList[] = [];
  @Input() senders: string[] = [];
  @Input() isManualContactsMailer: boolean = false;
  @Input() contactsMailerLoading: boolean = false;
  // Actif quand on édite la variante B d'un test A/B : seuls les champs expéditeur sont portés par la variante, le
  // reste du formulaire (destinataires, mailer, reply-to...) reste celui de la source live et ne doit pas
  // apparaître modifiable ici.
  @Input() abTestSenderOnlyMode: boolean = false;
  // Vrai s'il existe un test A/B prévu ou en cours sur cette source — alimente un warning purement informatif :
  // ne bloque rien, prévient juste que certaines personnalisations de B n'auront aucun effet sur ce mailer.
  @Input() hasEditableABTests: boolean = false;

  get selectedSendingMailerType(): string {
    const selectedMailer = this.contactsMailers.find(m => m?.id === this.sendingConfigForm.get('sendingMailer').value);
    return selectedMailer?.mailerType;
  }

  get showRestrictiveMailerWarning(): boolean {
    const selectedMailer = this.sendingMailers.find(m => m?.id === this.sendingConfigForm.get('sendingMailer')?.value);
    return this.hasEditableABTests && !!selectedMailer && !isFullyPersonalizable(selectedMailer);
  }

  /**
   * Les expéditeurs peuvent être fournis sous 2 formes :
   * - "<adresse_mail>"
   * - "<id>|<libellé>" (plus pratique pour le connecteur Batch)
   */
  get formattedSenders(): { name: string, value: string }[] {
    return this.senders.map(sender => {
      if (sender.includes('|')) {
        const splitted = sender.split('|');
        return { name: splitted[1], value: splitted[0] };
      }
      return { name: sender, value: sender };
    });
  }

  get specificSendingConf(): FormControl {
    return this.sendingConfigForm.get('specificSendingMailerConfiguration') as FormControl;
  }

  displayContactsListsName(contactsList: ContactList): string {
    return contactsList.name
  }

  updateManualContactLists(newContactLists: string[]): void {
    this.sendingConfigForm.get('contactsLists').setValue(newContactLists);
    this.sendingConfigForm.markAsTouched();
  }

  updateSelectedContactsLists(elements) {
    this.sendingConfigForm.markAsTouched(); // the multi-select component does not change the "touched" attribute natively.
    this.sendingConfigForm.get('contactsLists').setValue(elements);
  }

  restoreConfig() {
    this.sendingConfigForm.get('contactsMailer').setValue('');
    this.sendingConfigForm.get('contactsLists').setValue([]);
    this.sendingConfigForm.get('sendingMailer').setValue('');
    this.sendingConfigForm.get('senderName').setValue('');
    this.sendingConfigForm.get('senderAddress').setValue('');
    this.sendingConfigForm.get('replyToAddress').setValue('');
    this.sendingConfigForm.get('specificSendingMailerConfiguration').setValue(null);
    this.sendingConfigForm.markAsTouched();
  }

}
